export default __webpack_public_path__ + "static/media/first_today.cb37e928.png";